import { defineStore } from 'pinia'

import { useStorage } from '@vueuse/core'

import type { CategoryData } from '@/types/Incident'

const categoryType: CategoryData | null = null

export default defineStore('category', () => {
  const category = useStorage('category', categoryType as CategoryData | null)
  return { category }
})
